"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWeekday = void 0;
const getEasternTime_1 = require("../getEasternTime");
const parseInputDate_1 = require("../parseInputDate");
function isWeekday(date) {
    const dateTime = !date ? (0, getEasternTime_1.getEasternTimeLuxon)() : (0, parseInputDate_1.parseInputDate)(date);
    const dayOfWeek = dateTime.weekday;
    return dayOfWeek <= 5;
}
exports.isWeekday = isWeekday;
//# sourceMappingURL=index.js.map